const routes = [
  /* {
        path:'/user/*',
        component: () => import('../Seller/index'), 
        name : "user",
    },
    {
        path:'/admin/*',
        component: () => import('../Seller/index'), 
        name : "user",
    },
    {
        path:'/*',
        component : () => import('../../components/404'),
        name : "errorPage",
    },   */
];
export default routes;
